import { render, staticRenderFns } from "./SelectTabMulity.vue?vue&type=template&id=1ebdffca&scoped=true&"
import script from "./SelectTabMulity.vue?vue&type=script&lang=js&"
export * from "./SelectTabMulity.vue?vue&type=script&lang=js&"
import style0 from "./SelectTabMulity.vue?vue&type=style&index=0&id=1ebdffca&prod&lang=stylus&scoped=true&"
import style1 from "./SelectTabMulity.vue?vue&type=style&index=1&id=1ebdffca&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ebdffca",
  null
  
)

export default component.exports